import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import {
  TimelineUnassignedShiftIdsQueryParamKey,
  TimelineUnassignedShiftSearchesQueryParamKey,
  UnassignedShift,
} from '@wilson/interfaces';
import {
  SetUnassignedShiftIdsFilter,
  SetUnassignedShiftSearchesFilter,
} from '@wilson/shift-timeline/state';
import { DateTimeFormat } from '@wilson/utils';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { isUUIDLike } from '@wilson/utils';

@Component({
  selector: 'wilson-unassigned-region-search-filter',
  imports: [CommonModule, NzSelectModule, FormsModule, TranslateModule],
  templateUrl: './unassigned-region-search-filter.component.html',
  styleUrls: ['./unassigned-region-search-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnassignedRegionSearchFilterComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly store = inject(Store);

  @Input({ required: true }) unassignedShifts!: UnassignedShift[] | null;
  @Input({ required: true }) resourcesColumnWidthPx!: number | null;

  selectedUnassignedFilter: string[] = [];
  protected DateTimeFormat = DateTimeFormat;

  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const unassignedShiftIdsQueryParams: string =
      queryParams[TimelineUnassignedShiftIdsQueryParamKey];
    const unassignedShiftSearchesQueryParams: string =
      queryParams[TimelineUnassignedShiftSearchesQueryParamKey];

    const unassignedShiftIds = unassignedShiftIdsQueryParams
      ? unassignedShiftIdsQueryParams.split(',')
      : [];
    const unassignedShiftSearches = unassignedShiftSearchesQueryParams
      ? unassignedShiftSearchesQueryParams.split(',')
      : [];
    this.selectedUnassignedFilter = [
      ...unassignedShiftIds,
      ...unassignedShiftSearches,
    ];
    this.dispatchSetFilterActions(unassignedShiftIds, unassignedShiftSearches);
  }

  public setUnassignedShiftsFilter(selectedFilters: string[]): void {
    const unassignedShiftIds: string[] = [];
    const unassignedShiftSearches: string[] = [];

    selectedFilters.forEach((filter) => {
      if (isUUIDLike(filter)) {
        unassignedShiftIds.push(filter);
      } else {
        unassignedShiftSearches.push(filter);
      }
    });
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        [TimelineUnassignedShiftIdsQueryParamKey]: unassignedShiftIds.length
          ? unassignedShiftIds.join(',')
          : null,
        [TimelineUnassignedShiftSearchesQueryParamKey]:
          unassignedShiftSearches.length
            ? unassignedShiftSearches.join(',')
            : null,
      },
      queryParamsHandling: 'merge',
    });
    this.dispatchSetFilterActions(unassignedShiftIds, unassignedShiftSearches);
  }

  private dispatchSetFilterActions(
    unassignedShiftIds: string[],
    unassignedShiftSearches: string[],
  ): void {
    this.store.dispatch(new SetUnassignedShiftIdsFilter(unassignedShiftIds));
    this.store.dispatch(
      new SetUnassignedShiftSearchesFilter(unassignedShiftSearches),
    );
  }
}
